import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import { Table, TableTh, TableRow } from './Table';
import { ProductTabRowTable } from '../Product/ProductTabRowTable';
import { __ } from 'react-i18n';
import { NoItemsWrapper } from './NoItemsWrapper';

export interface Props {
  columns?: Array<{ name: string; align?: string }>;
  rows: any[];
  noItemsText?: string;
  tableHasBoxShadow?: boolean;
  tableHasBorder?: boolean;
  headers?: any[];
  overflowX?: boolean;
}

function TableWrapper({
  columns,
  rows,
  noItemsText = __('Nenašli sa žiadne výsledky'),
  tableHasBoxShadow,
  tableHasBorder,
  headers,
  overflowX,
}: Props) {
  return (
    <Wrapper overflowX={overflowX}>
      {!rows || rows.length === 0 ? (
        <NoItemsWrapper height={300} text={noItemsText} />
      ) : (
        <StyledTable
          hasBoxShadow={tableHasBoxShadow}
          hasBorder={tableHasBorder}
        >
          <thead>
            <tr>
              {headers
                ? headers
                : columns &&
                  columns.map((item, i) => (
                    <TableTh align={item.align || 'left'} key={i}>
                      {item.name}
                    </TableTh>
                  ))}
            </tr>
          </thead>
          <tbody>{rows}</tbody>
        </StyledTable>
      )}
    </Wrapper>
  );
}

const Wrapper = styled.div<{ overflowX?: boolean }>`
  overflow-x: auto;
  overflow-y: ${({ overflowX }) => (overflowX ? 'auto' : 'hidden')};
  margin-bottom: ${rem(56)};
  width: 100%;
  max-height: ${({ overflowX }) => (overflowX ? rem(500) : 'initial')};

  &:last-child {
    margin-bottom: 0;
  }

  ${({ theme }) => theme.mediab.m580`
    margin-right: -${rem(16)};
  `}
`;

const StyledTable = styled(Table)<{
  hasBoxShadow?: boolean;
  hasBorder?: boolean;
}>`
  box-shadow: ${({ hasBoxShadow, theme }) =>
    hasBoxShadow ? theme.boxShadow.input : ''};
  border: ${({ hasBorder, theme }) => (hasBorder ? theme.borders.table : '')};
  border-radius: ${rem(4)};

  ${({ theme }) => theme.mediab.m580`
    min-width: ${rem(550)};
  `}
`;

export { TableWrapper };
